import React from 'react';
import { Block } from '@bgea-js/react-ui';

const customConfirmationGT = ({
  showRecurrenceText = '',
  recurrenceText = '',
  transactionId = 0,
  total = 0,
} = {}) => (
  <div>
    <h4>Thank You for Your Gift</h4>
    <Block>
      We are grateful for your heart to spread God&apos;s Word—and the Good
      News—to the U.S.-Mexico border through the Franklin Graham Frontera God
      Loves You Tour.
    </Block>
    <Block>
      Your generosity will help equip a new believer with a Bible to help them
      grow in their faith in Jesus Christ.
    </Block>
    <Block>
      The confirmation number for your{' '}
      {showRecurrenceText && <strong>{recurrenceText}</strong>} donation is{' '}
      <strong>{transactionId}</strong> for the amount of $
      {total.toFixed(2) ?? 'NEED AMOUNT'}.
    </Block>
    <Block>
      If you have any questions, call us at 1-877-247-2426. Please have your
      confirmation number ready and indicate that you are contacting us about a
      donation made through the Billy Graham Evangelistic Association website.
    </Block>
    <Block>
      To keep you updated on the ministry, we would like to send you our prayer
      letter, <i>From the Desk of Franklin Graham</i>, featuring biblical truths
      about current events, news of his travels and updates on the work of BGEA
      with thousands of people around the world. You can opt-out from receiving
      these emails anytime.
    </Block>
  </div>
);

export default customConfirmationGT;
